import { useMemo } from 'react';
import { intersection } from 'lodash';
import PropTypes from 'prop-types';

import { SLATE_EDITOR_ACTIONS } from 'src/lib/slate';

import { ALWAYS_VISIBLE_ACTIONS } from '../../../lib';
import { EditorActionButton } from '../../EditorActionButton';

export const ToolbarUndoRedoActions = ({ className, editorActions, onAction, disabled }) => {
  const actions = useMemo(
    () => intersection(editorActions, ALWAYS_VISIBLE_ACTIONS),
    [editorActions]
  );

  return (
    <div className={className}>
      {actions.map((action) => (
        <EditorActionButton
          key={action}
          action={action}
          onAction={onAction}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

ToolbarUndoRedoActions.propTypes = {
  className: PropTypes.string,
  editorActions: PropTypes.arrayOf(PropTypes.oneOf(SLATE_EDITOR_ACTIONS)).isRequired,
  onAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ToolbarUndoRedoActions.defaultProps = {
  className: '',
  disabled: false,
};
